module.exports = __webpack_public_path__ + "img/logo-dc.99fcd96a.svg";